import { Container, Box, Stack, Alert, AlertTitle } from "@mui/material";
import React, { useState } from "react";
import Input from "../components/Base/Input";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
//import UploadDocument from '../components/common/UploadDocument';
import Note from "../components/common/Note";
import configData from "../Config";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { useNavigate, useLocation } from "react-router-dom";

import styles from "../Style/Modules/login.module.css";
import "../Style/Theme/index.css";

import { apis } from "../services/apiService";
import AlertPopup from "../components/common/AlertPopup";
export default function UploadUdhyam() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        formfile: file,
        fileName: fileName,
        filetype: "Udyam",
        aid: location.state.AppId,
      };
      let resp = await apis.postWithFilesApi(
        configData.API_URL + "UploadDocument/UploadUdyam",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        let data = { AppId: location.state.AppId };
        navigate("/upload-income-proof", { state: data });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
    }
  };
  const savefile = (e) => {
    if (e.target.files?.length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
      setDisabled(false);
    } else {
      setFile(undefined);
      setFileName(undefined);
      setDisabled(true);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={5} />
        <IntroCard
          title="Upload Udhyam Registration"
          subtitle="Upload document to proceed"
          img="/assets/udhyogAdhar.svg"
        />
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "" }}>
            <Input
              type="file"
              onChange={savefile}
              autoComplete="off"
              name="gstCertificate1"
              id="gstCertificateId"
              accept=".zip,application/pdf"
            />
          </Box>
          <Box sx={{ paddingBottom: "40px" }}>
            <Note
              udyamNote="udyamNote"
              note="Only files with .pdf or .zip extension allowed"
            />
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
      </Container>
    </>
  );
}
